module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.fa3334f.woff2";